import React, { useCallback } from "react";
import { useTranslation } from "components/translations/useTranslation";
import { MODAL_CONTENT_TAB_INDEX } from "utils/constants";
import OKCancelButtons from "components/modals/OKCancelButtons";
import * as reduxSelectors from "components/store/application.reducers";
import { useDispatch, useSelector } from "react-redux";
import { deleteAttachment } from "components/modals/modal.actions";
import { Store } from "redux";
import { DeleteActionData, DeleteAttachmentProps } from "types/modals";

const DeleteAttachment = ({ more, closeModal, loopFocus, errorCallback, initialFocusRef }: DeleteAttachmentProps): React.ReactElement => {
    const { translate } = useTranslation();
    const selected = useSelector((store: Store) => reduxSelectors.getSelectedDocument(store));
    const dispatch = useDispatch();

    const handleDelete = useCallback(() => {
        const currentTask = more?.tasks[0];
        if (!currentTask) return;

        const data: DeleteActionData = {
            key: currentTask.key,
            collectionGuid: currentTask.attachmentCollectionValues.latestAttachmentCollectionGuid,
            id: selected.id,
            deleteMessage: translate("popUp.deleteAttachment.hasBeenRemoved"),
        };

        dispatch(deleteAttachment(data, closeModal, errorCallback));
    }, [more, selected, translate, dispatch, closeModal, errorCallback]);

    return (
        <>
            <div className="ga-modal__content" />
            <OKCancelButtons
                tabIndex={MODAL_CONTENT_TAB_INDEX + 1}
                okEnabled={true}
                okCallback={handleDelete}
                okText={translate("popUp.deleteAttachment.deleteButton")}
                cancelEnabled={true}
                cancelCallback={closeModal}
                cancelText={translate("popUp.deleteAttachment.keepButton")}
                loopFocus={loopFocus}
                cancelRef={initialFocusRef}
            />
        </>
    );
};

export default DeleteAttachment;
